export enum EOposNumberOfExams {
  ZERO = 'ZERO',
  ONE = 'ONE',
  TWO = 'TWO',
  THREE = 'THREE',
  MORE_THAN_THREE = 'MORE_THAN_THREE'
}

export const OPOS_NUMBER_OF_EXAMS = Object.values(EOposNumberOfExams);
